import { useApiClient } from '@/composables/useApiClient'

export type TextAssistantAction =
  | 'generate'
  | 'summarize'
  | 'develop'
  | 'formalize'
  | 'improve'
  | 'reduce'
  | 'custom'

export interface ITextAssistantActionRequest {
  action: TextAssistantAction
  text: string
  instruction: string
  domain_code?: string | null
}

export interface ITextAssistantActionResponse {
  action: TextAssistantAction
  result: string
}

export const useTextAssistantService = () => {
  const privateApi = useApiClient(true)

  const executeAction = async (payload: ITextAssistantActionRequest) => {
    return privateApi.post<ITextAssistantActionResponse, ITextAssistantActionRequest>(
      '/oper/ai/text-assistant/action',
      payload,
    )
  }

  return {
    executeAction,
  }
}
